
/**
 * Utility functions for Supabase Storage
 */

/**
 * Extracts the file path from a storage URL or raw path
 * Handles standard Supabase public/signed URLs and simple paths
 */
export function extractPathFromUrl(url: string | null | undefined, bucketName: string): string | null {
    if (!url) return null;

    try {
        // 1. Remove query parameters (cache busters or tokens)
        const urlWithoutQuery = url.split('?')[0];

        // 2. Define patterns to look for
        const patterns = [
            // Standard Supabase URL: /storage/v1/object/(public|sign)/bucket/path
            new RegExp(`/storage/v1/object/(?:public|sign|info|info/public)/${bucketName}/(.+)$`),
            // Shorter path sometimes used in logging or internal APIs: /object/public/bucket/path
            new RegExp(`/object/(?:public|sign|info|info/public)/${bucketName}/(.+)$`),
            // Relative path or just includes the bucket name: bucket/path
            new RegExp(`${bucketName}/(.+)$`)
        ];

        for (const pattern of patterns) {
            const match = urlWithoutQuery.match(pattern);
            if (match && match[1]) {
                // Decode URI components in case the path has spaces/special chars
                return decodeURIComponent(match[1]);
            }
        }

        // 3. Fallback: If no pattern matched but the string doesn't look like a full URL,
        // it might already be just the path
        if (!urlWithoutQuery.includes('://') && !urlWithoutQuery.startsWith('/')) {
            return urlWithoutQuery;
        }

        return null;
    } catch (err) {
        console.error('Error extracting path from URL:', err);
        return null;
    }
}
